module.exports = __webpack_public_path__ + "static/tanks-744daf37e00cc7a3b2ce7019cef3e01e.jpg";